<template>
  <ion-page>
    <ion-content fullscreen />
    <ion-footer class="ion-padding footer-onboarding ion-text-center">
      <logo />
      <h1>{{ $t('install.title') }}</h1>
      <p class="ion-padding-x text-sm">
        {{ $t('install.chrome') }}
      </p>
      <ion-button
        fill="clear"
        expand="block"
        color="medium"
        class="text-sm underline ion-margin"
        @click="modalController.dismiss()"
      >
        {{ $t('install.skip') }}
      </ion-button>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import { IonFooter, modalController } from '@ionic/vue';
import Logo from '@/components/Logo.vue';

export default defineComponent({
  components: {
    IonFooter,
    Logo,
  },
  setup() {
    return {
      modalController,
    };
  },
});
</script>

<style scoped>
ion-content {
  --background: none;
}

ion-thumbnail {
  margin: 16px auto;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);

  --size: 70px;
}
</style>
